import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink01 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.5058 5.99444C12.8312 6.31987 12.8312 6.84751 12.5058 7.17295L6.67248 13.0063C6.34704 13.3317 5.8194 13.3317 5.49397 13.0063C5.16853 12.6808 5.16853 12.1532 5.49397 11.8278L11.3273 5.99444C11.6527 5.669 12.1804 5.669 12.5058 5.99444Z",
			fill: "#4A55CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.28584 8.32187C4.61128 8.6473 4.61128 9.17494 4.28584 9.50038L3.10733 10.6789C1.80559 11.9806 1.80559 14.0912 3.10733 15.3929C4.40908 16.6947 6.51963 16.6947 7.82138 15.3929L8.99989 14.2144C9.32533 13.889 9.85296 13.889 10.1784 14.2144C10.5038 14.5399 10.5038 15.0675 10.1784 15.3929L8.99989 16.5714C7.04727 18.5241 3.88144 18.5241 1.92882 16.5714C-0.0238003 14.6188 -0.0237995 11.453 1.92882 9.50038L3.10733 8.32187C3.43277 7.99643 3.96041 7.99643 4.28584 8.32187Z",
			fill: "#4A55CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.99989 2.42931C10.9525 0.476689 14.1183 0.476688 16.071 2.42931C18.0236 4.38193 18.0236 7.54776 16.071 9.50038L14.8924 10.6789C14.567 11.0043 14.0394 11.0043 13.7139 10.6789C13.3885 10.3535 13.3885 9.82581 13.7139 9.50038L14.8924 8.32187C16.1942 7.02012 16.1942 4.90957 14.8924 3.60782C13.5907 2.30607 11.4801 2.30607 10.1784 3.60782L8.99989 4.78633C8.67445 5.11177 8.14682 5.11177 7.82138 4.78633C7.49594 4.4609 7.49594 3.93326 7.82138 3.60782L8.99989 2.42931Z",
			fill: "#4A55CF"
		})
	]
});
export default SvgLink01;
